import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { IGetPagoInfo } from '../../shared/interfaces/database/recaudo';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PagoService {

  private readonly baseUrl = `${environment.apiUrl}/api/pagos`;

  constructor(private http: HttpClient) { }

  getPagosInfo(tramRegistroId: number): Observable<IGetPagoInfo> {
    return this.http.get<IGetPagoInfo>(`${this.baseUrl}/pago-info/${tramRegistroId}`);
  }
}
